<div *ngIf="showPanel$ | async" class="flex justify-content-left">
  <p-button (onClick)="doShowDialog(true)">OIB servis</p-button>
</div>

<app-oib-service-dialog [(showDialog)]="showDialog" [loadingOib]="loadingOib" [oib]="oib" [oibReadonly]="oibReadonly"
  [dirty]="dirty" [oibResponse]="oibResponse" [fetchError]="fetchError" [applyError]="applyError"
  (searchClicked)="search()" (applyClicked)="apply()" (closeClicked)="doShowDialog(false)"></app-oib-service-dialog>